module.exports = __webpack_public_path__ + "static/media/PASCLAIR.ec9bf1c0.svg";